// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  max-width: 1300px !important;
  margin: 0 auto;
  width: 100%;
}

h1 {
  font-size: 104px;
  font-weight: 700;
  line-height: 116px;
  color: #f8f8f8;
}

h2 {
  font-size: 18px;
  line-height: 21px;
  font-weight: 600;
  text-align: center;
  color: #ffffff;
  margin-top: 30px;
}
@media screen and (min-width: 495px) {
  h2 {
    font-size: 48px;
    line-height: 72px;
  }
}

h3 {
  font-size: 25px;
  color: #000;
  padding-bottom: 15px;
}

p {
  font-size: 14px;
  line-height: 24px;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  padding-right: 20px;
}
@media screen and (min-width: 495px) {
  p {
    font-size: 24px;
    line-height: 40px;
  }
}
p.small {
  text-align: left;
  font-size: 10px;
  font-weight: 400;
  color: #ffffff;
  line-height: 13px;
}
@media screen and (min-width: 495px) {
  p.small {
    font-size: 18px;
    line-height: 24px;
  }
} `, "",{"version":3,"sources":["webpack://./src/styles/global.scss","webpack://./src/styles/global.css"],"names":[],"mappings":"AAAA;EACE,4BAAA;EACA,cAAA;EACA,WAAA;ACCF;;ADCA;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;ACEF;;ADAA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;ACGF;ADFE;EAPF;IAQI,eAAA;IACA,iBAAA;ECKF;AACF;;ADHA;EACE,eAAA;EACA,WAAA;EACA,oBAAA;ACMF;;ADHA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;ACMF;ADLE;EAPF;IAQI,eAAA;IACA,iBAAA;ECQF;AACF;ADNE;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;ACQJ;ADPI;EANF;IAOI,eAAA;IACA,iBAAA;ECUJ;AACF","sourcesContent":[".container {\n  max-width: 1300px !important;\n  margin: 0 auto;\n  width: 100%;\n}\nh1 {\n  font-size: 104px;\n  font-weight: 700;\n  line-height: 116px;\n  color: #f8f8f8;\n}\nh2 {\n  font-size: 18px;\n  line-height: 21px;\n  font-weight: 600;\n  text-align: center;\n  color: #ffffff;\n  margin-top: 30px;\n  @media screen and (min-width: 495px) {\n    font-size: 48px;\n    line-height: 72px;\n  }\n}\nh3 {\n  font-size: 25px;\n  color: #000;\n  padding-bottom: 15px;\n}\n\np {\n  font-size: 14px;\n  line-height: 24px;\n  font-weight: 400;\n  text-align: center;\n  color: #ffffff;\n  padding-right: 20px;\n  @media screen and (min-width: 495px) {\n    font-size: 24px;\n    line-height: 40px;\n  }\n\n  &.small {\n    text-align: left;\n    font-size: 10px;\n    font-weight: 400;\n    color: #ffffff;\n    line-height: 13px;\n    @media screen and (min-width: 495px) {\n      font-size: 18px;\n      line-height: 24px;\n    }\n  }\n}\n",".container {\n  max-width: 1300px !important;\n  margin: 0 auto;\n  width: 100%;\n}\n\nh1 {\n  font-size: 104px;\n  font-weight: 700;\n  line-height: 116px;\n  color: #f8f8f8;\n}\n\nh2 {\n  font-size: 18px;\n  line-height: 21px;\n  font-weight: 600;\n  text-align: center;\n  color: #ffffff;\n  margin-top: 30px;\n}\n@media screen and (min-width: 495px) {\n  h2 {\n    font-size: 48px;\n    line-height: 72px;\n  }\n}\n\nh3 {\n  font-size: 25px;\n  color: #000;\n  padding-bottom: 15px;\n}\n\np {\n  font-size: 14px;\n  line-height: 24px;\n  font-weight: 400;\n  text-align: center;\n  color: #ffffff;\n  padding-right: 20px;\n}\n@media screen and (min-width: 495px) {\n  p {\n    font-size: 24px;\n    line-height: 40px;\n  }\n}\np.small {\n  text-align: left;\n  font-size: 10px;\n  font-weight: 400;\n  color: #ffffff;\n  line-height: 13px;\n}\n@media screen and (min-width: 495px) {\n  p.small {\n    font-size: 18px;\n    line-height: 24px;\n  }\n} /*# sourceMappingURL=global.css.map */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
